import { motion } from "framer-motion";
import { Quote } from "lucide-react";

// NOTE FOR KATHLEEN: replace these with real, consented patient testimonials.
// Healthcare best practice: use first-name + last-initial OR initials only,
// city + clinical context. Always get written consent before publishing.
const testimonials = [
  {
    quote:
      "After my stroke, putting words together felt like wading through mud. Six months in, my husband says I sound like myself again — and I believe him.",
    name: "M.K.",
    detail: "Dublin · Post-CVA aphasia recovery",
  },
  {
    quote:
      "Kathleen made the voice exercises feel less like therapy and more like reclaiming a part of me. My grandkids can hear me on the phone now without asking me to repeat myself.",
    name: "J.O.",
    detail: "Massachusetts · Parkinson's / SPEAK OUT!®",
  },
  {
    quote:
      "Honest, kind, and seriously good at what she does. She helped my mother eat safely again, and that gave our family the dinner table back.",
    name: "D.R.",
    detail: "Galway · Family member, dysphagia care",
  },
];

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="relative py-20 md:py-32 bg-[#F3F1E7]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-14">
          <div className="lg:col-span-7">
            <p className="text-xs uppercase tracking-[0.25em] text-[#5C6661] mb-4">
              In their own words
            </p>
            <h2
              data-testid="testimonials-title"
              className="font-serif text-3xl md:text-4xl lg:text-5xl font-light tracking-tight text-[#2D332F] leading-tight"
            >
              Small wins that
              <br />
              <em className="text-[#739072]">change everything.</em>
            </h2>
          </div>
          <p className="lg:col-span-5 text-[#5C6661] text-lg leading-relaxed self-end">
            Every story is unique — but the goal is always the same: more
            confidence, more clarity, and more connection in everyday life.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <motion.figure
              key={t.name}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="relative rounded-3xl border border-black/5 bg-[#FDFCF8] p-8 md:p-10 hover:-translate-y-1 hover:shadow-lg transition-all duration-500"
            >
              <Quote
                size={26}
                strokeWidth={1.3}
                className="text-[#739072] mb-5 opacity-80"
              />
              <blockquote className="font-serif text-xl md:text-2xl font-light leading-snug text-[#2D332F] mb-6">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="border-t border-black/5 pt-4">
                <p className="font-medium text-[#2D332F]">{t.name}</p>
                <p className="text-xs uppercase tracking-[0.18em] text-[#5C6661] mt-1">
                  {t.detail}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>

        <p className="mt-12 text-xs text-[#5C6661] max-w-2xl">
          Names abbreviated to protect patient privacy. All testimonials shared
          with written consent.
        </p>
      </div>
    </section>
  );
};
